import Form, { useForm } from '@eversports/klimt-forms/Form'
import RadioGroup from '@eversports/klimt-forms/RadioGroup'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import * as React from 'react'
import { useEffect } from 'react'

import ModalOption from '../../../../../components/ModalOption'
import ModalRadioButton from '../../../../../components/ModalRadioButton'
import { Localized } from '../../../../../localization/react'
import { MatchLevel, MatchMissingField } from '../../../Match.types'
import RequiredLevelContent from '../components/RequiredLevelContent'
import { Action } from '../helpers/match-settings-reducer'

import ResetField from './components/ResetField'
import { RequiredLevelForm } from './MatchSettingsModal.types'

interface Props {
  dispatch: React.Dispatch<Action>
  initialLevel?: MatchLevel | null
  isRequired?: boolean
}

const RequiredLevel = ({ dispatch, initialLevel, isRequired = false }: Props) => {
  const methods = useForm<RequiredLevelForm>({
    defaultValues: { LEVEL: initialLevel },
  })

  const requiredLevel = methods.watch(MatchMissingField.LEVEL)

  useEffect(() => {
    if (!requiredLevel) return
    dispatch({ type: 'UPDATE_MATCH_LEVEL', payload: requiredLevel })
  }, [requiredLevel])

  const resetField = () => {
    methods.reset({ LEVEL: null })
    dispatch({ type: 'UPDATE_MATCH_LEVEL', payload: null })
  }

  return (
    <Stack gap={2}>
      <Stack direction="row" gap={0.5}>
        <Text variant="small" sx={{ fontWeight: 'bold' }}>
          <Localized id="match-rule-level-title" />
        </Text>
        {isRequired && <Text sx={{ color: 'red', fontWeight: 'bold', verticalAlign: 'text-top' }}>*</Text>}
        {requiredLevel && <ResetField onClick={resetField} />}
      </Stack>
      <Form methods={methods}>
        <RadioGroup name={MatchMissingField.LEVEL}>
          <Stack gap={2}>
            {Object.keys(MatchLevel).map((level) => (
              <ModalOption key={level} isSelected={level === (requiredLevel as string | null)}>
                <ModalRadioButton label={<RequiredLevelContent level={level as MatchLevel} />} value={level} />
              </ModalOption>
            ))}
          </Stack>
        </RadioGroup>
      </Form>
    </Stack>
  )
}

export default RequiredLevel
